/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 $('.qty .btnqty').on('click', function(){
    var qty = parseInt($(this).parent('.qty').find('.quantity-input').val());
    if($(this).hasClass('qtyplus')) {
      qty++;
    }else {
      if(qty > 1) {
        qty--;
      }
    }
    qty = (isNaN(qty))?1:qty;
    $(this).parent('.qty').find('.quantity-input').val(qty);
  }); 
$(".add-variant").click(function (event) {
  event.preventDefault();
  let target = event.target;
  let qty  = target.closest('tr').querySelector('.quantity-input').value;
  var current_variant = $(this).attr("variant-add");
  // alert(current_variant)
  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      quantity: qty,
      id: current_variant,
    },
    dataType: "json",
    success: function () {
      document.documentElement.dispatchEvent(
        new CustomEvent("product:added", {
          bubbles: true,
          detail: {
            variant: current_variant,
            quantity: qty,
          },
        })
      );
    },
  });
});


$(".myImg").click(function() {
  $('#img01').attr("src", $(this).attr('data-variant-src'))
  $('#myModal').show();
  //modalImg.src = this.src;
  
  $(".close").click(function() {
    $('#myModal').hide();
  })
});
//Bulk Products Section//
let form_Data = [];
$('.cart-button--box').click(function(e){
  e.preventDefault();
  $('.p--varient').each(function(e){
      var main_div = $(this).find('.c-qty-slct');
      var var_id = $(main_div).attr('variant');
      var var_qty = $(main_div).find('.quantity-input').val();
    var qty = parseInt(var_qty);
      if(qty > 0){
      form_Data.push({
          id: var_id,
          quantity: qty
      });
    }
  })
  if(form_Data.lenght == 0) return;
  jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {items: form_Data },
      dataType: 'json',
      success: function () {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
          }));
          let btn = document.querySelector('.cart---icon');
          var mEvent = document.createEvent("MouseEvent");
          mEvent.initMouseEvent("click", true, true, window, 0,
              0, 0, 0, 0,
              false, false, false, false,
              0, null);
          btn.dispatchEvent(mEvent);

          form_Data = [];
          setTimeout(function(){
          $('.p--varient').each(function(){
            $(this).removeClass('active');
          })
          $('.quantity-input').each(function(e){
              $(this).val(0);
          })
          }, 3000);
      },
  });
})



//get sample start//
$(document).ready(function(){
  setTimeout(function(){$('#dummy-chat-button-iframe').addClass('btn-down');},1500);
  $("button.sample_add_variant.get_sample").each(function(i) {
    i=i-1;
    $(this).attr("btn__index",+ (i+1));
  });
  $(".product-samples-placeholder").each(function(c) {
    c=c-1;
    $(this).attr('id', 'box_'+ (c+1));
  });
  $( "button.sample_add_variant.get_sample" ).on("click", function() {
    
    if ($('#all_entries_check').attr("value")=="false"){
      $('.overlay.alert_popup').addClass('popup_active');
      $('p.login_msg').show();
      $('.popup .close, .overlay').click(function(){
        $('.overlay.alert_popup').removeClass('popup_active');
      });
      return false;
    }else{
      $('#sampleModal').fadeIn(300);
      $('.product-samples-widget__trigger').fadeOut(150);
      $('#dummy-chat-button-iframe').addClass('chat_us');
      $(".sample_modal_close").click(function() {
        $('#sampleModal').fadeOut(200);
        $('.product-samples-widget__trigger').fadeIn(300);
        $('.sample-error-msg').fadeOut(100);
        $('#dummy-chat-button-iframe').removeClass('chat_us');
        $('#dummy-chat-button-iframe').addClass('btn-down');
      });
      // Parse any JSON previously stored in allEntries
      var existingEntries = JSON.parse(localStorage.getItem("allEntries"));
      if(existingEntries == null) existingEntries = [];
      var variantimg = $(this).parent().attr('var_img_src');
      var variantTitle = $(this).parent().attr('vr_title');
      var productTitle = $(this).parent().attr('product-title');
      var variantId = $(this).parent().attr('variant');
      var entry = {
        "variantId": variantId,
        "variantTitle": variantTitle,
        "variantImage": variantimg,
        "productTitle": productTitle
      };
    var already_exists = false;
    for(var i = 0; i < existingEntries.length; i++){
    if (existingEntries[i].variantId == variantId){
      already_exists = true;
    }
    }
    if (already_exists == true){
      $('.overlay.alert_popup').addClass('popup_active');
      $('p.already_exist').show();
      $('p.choose_item').hide();
      $('.alert-popup-close').hide();
      $('.popup .close, .overlay').click(function(){
        $('.overlay.alert_popup').removeClass('popup_active');
      });
      return;
    }else{
      // Save allEntries back to local storage
      localStorage.setItem("entry", JSON.stringify(entry));
      existingEntries.push(entry);
      if (existingEntries.length == 4){
        $('.sample-error-msg').html('Cannot get samples more than (3)').show();
        return false;
      }else{
        $('.sample-error-msg').html('');
      localStorage.setItem("allEntries", JSON.stringify(existingEntries));
      }
      }  
      var existingEntries = JSON.parse(localStorage.getItem("allEntries"));
      for(var i = 0; i < existingEntries.length; i++){
      var vId = (existingEntries[i].variantId);
      var pTitle = (existingEntries[i].productTitle);
      var vrTitle = (existingEntries[i].variantTitle);
      var allData = vId+'/'+pTitle+'/'+vrTitle;
      $('[name="properties[ProductSample]"]').val(allData);
      var selectedBox = $('#box_'+i);
      (selectedBox).remove();
      var selectedBox = $('#box_'+i);
      if(selectedBox.length == 0){
        $(".product-samples-widget__grid.ps").prepend('<div class="product-samples-placeholder" id="box_'+i+'"><span class="sample_card_close">close</span><span>Samples</span></div>');
        var selectedBox = $('#box_'+i);
      }
      var varimg = (existingEntries[i].variantImage);
      $(selectedBox).addClass('active');
      $(selectedBox).css('background-image', 'url(' + varimg + ')');
      }
      }
  });
  var existingEntries = JSON.parse(localStorage.getItem("allEntries"));
  if(existingEntries != null){
  
  for(var i = 0; i < existingEntries.length; i++){
  var selectedBox = $('#box_'+i);
  (selectedBox).remove();
  var selectedBox = $('#box_'+i);
  if(selectedBox.length == 0){
    $(".product-samples-widget__grid.ps").prepend('<div class="product-samples-placeholder" id="box_'+i+'"><span class="sample_card_close">close</span><span>Samples</span></div>');
    var selectedBox = $('#box_'+i);
  }
  var varimg = (existingEntries[i].variantImage);  
  $(selectedBox).addClass('active');
  $(selectedBox).css('background-image', 'url(' + varimg + ')');
  }
  }
$('.product-samples-widget__trigger').click(function(){ 
  $('#sampleModal').fadeIn(300);
  $(this).fadeOut(150);
  setTimeout(function(){
        $('#dummy-chat-button-iframe').addClass('chat_us');
  },100);
  $(".sample_modal_close").click(function() {
    $('#sampleModal').fadeOut(200);
    $('.product-samples-widget__trigger').fadeIn(300);
    $('#dummy-chat-button-iframe').removeClass('chat_us');
    $('#dummy-chat-button-iframe').addClass('btn-down');
  });
});
$(document).on('click' , '.sample_card_close' , function(){
$(this).css("display", "none");
$(this).parent('.product-samples-placeholder').removeClass('active')
  .css({"background-image": 'none'});
  var sc = $(this).parent('.product-samples-placeholder').attr('id');
  var existingEntries = JSON.parse(localStorage.getItem("allEntries"));
  existingEntries.splice(sc, 1);
  localStorage.setItem("allEntries", JSON.stringify(existingEntries));
});
$("button.product-samples-widget__checkout").click(function(){
  if ($('#all_entries_check').attr("value")=="false"){
    $('.overlay.alert_popup').addClass('popup_active');
    $('p.login_msg').show();
    $('.popup .close, .overlay').click(function(){
      $('.overlay.alert_popup').removeClass('popup_active');
    });
    return false;
  }else{
  var existingEntries = JSON.parse(localStorage.getItem("allEntries"));
  var properties= {};
  for(var i = 0; i < existingEntries.length; i++){
    if(i == 0){
      let pt = existingEntries[i].productTitle; 
      let vt = existingEntries[i].variantTitle
      properties[vt] = pt ;
      mycars = JSON.stringify(properties);
    }else{
     
      let pt = existingEntries[i].productTitle; 
      let vt = existingEntries[i].variantTitle
      properties[vt] = pt ;
    }
  }
   var sample_checkout_data = {
    items: [
      {
        id: 43221336359131,
        quantity: 1,
        properties: properties
      }
    ]
  };
  if (existingEntries.length < 1) {
    $('.alert-popup-close').hide();
    $('.overlay.alert_popup').addClass('popup_active');
    $('p.choose_item').show();
    $('p.login_msg').hide();
    $('p.already_exist').hide();
    $('.popup .close, .overlay').click(function(){
      $('.overlay.alert_popup').removeClass('popup_active');
    });
    return false;
  }else{
  $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: sample_checkout_data,
      dataType: 'json',
      success: function () {
        window.location = "/checkout";
      },
    });
   }
  }
});
});
//get sample end//